// extracted by mini-css-extract-plugin
export default {"container":"TitleWithTip_container__S5P4j","title":"TitleWithTip_title__m3IOI"};